import axios from 'axios';
import config from '../config';
import { determineHHPModelEventLocation } from '../helpers/rules';

const BARE_ECS_SUIT_KEY = /^ecs-suit-\d+$/;

function warnOnCollapsedEcsIndex(response) {
  Object.keys(response).forEach((location) => {
    Object.keys(response[location]).forEach((date) => {
      const ecs = response[location][date].ecs_suit_data;
      if (!ecs) return;
      const thingNames = Object.keys(ecs);
      const onlyBareKey = thingNames.length === 1 && BARE_ECS_SUIT_KEY.test(thingNames[0]);
      if (onlyBareKey) {
        // eslint-disable-next-line no-console
        console.warn(
          `Probable download-index collapse: ${location} ${date} has a single bare ECS key `
          + `"${thingNames[0]}" (no color suffix). Multi-umbilical days should expose one entry `
          + 'per color; the index-builder may have collapsed them.',
        );
      }
    });
  });
}

export function processListData(data) {
  const response = {};
  Object.keys(data || {}).forEach((date) => {
    if (typeof data[date] !== 'object' || data[date] === null) return;
    Object.keys(data[date] || {}).forEach((thingName) => {
      const location = determineHHPModelEventLocation(thingName);
      const thingData = data[date][thingName];
      if (typeof thingData !== 'object' || thingData === null) return;

      const {
        tableName,
        minTime,
        maxTime,
        evNum,
      } = thingData || {};
      if (!response[location]) {
        response[location] = {};
      }
      if (!response[location][date]) {
        response[location][date] = {};
      }
      if (!response[location][date][tableName]) {
        response[location][date][tableName] = {};
      }
      thingData.date = date;
      thingData.location = location;
      thingData.thingName = thingName;
      thingData.evNum = evNum;
      thingData.minTime = minTime;
      thingData.maxTime = maxTime;
      response[location][date][tableName][thingName] = thingData;
    });
  });
  warnOnCollapsedEcsIndex(response);
  return response;
}

export const request = async ({
  mrDate,
  mrMaxTime,
  mrMinTime,
  mrThingName,
  hrDate,
  hrMaxTime,
  hrMinTime,
  hrThingName,
  htDate,
  htMaxTime,
  htMinTime,
  htThingName,
  ecsDate,
  ecsMaxTime,
  ecsMinTime,
  ecsThingName,
  timelineFile,
  timelineFilename,
}) => {
  const { dataUrl, dataApiKey } = config || {};
  return axios({
    url: `${dataUrl}/combined-met-heart-rate`,
    method: 'POST',
    data: {
      timelineFilename,
      timelineFile,
    },
    params: {
      mr_date: mrDate,
      mr_max_time: mrMaxTime,
      mr_min_time: mrMinTime,
      mr_thing_name: mrThingName,
      hr_date: hrDate,
      hr_max_time: hrMaxTime,
      hr_min_time: hrMinTime,
      hr_thing_name: hrThingName,
      ht_date: htDate,
      ht_max_time: htMaxTime,
      ht_min_time: htMinTime,
      ht_thing_name: htThingName,
      ecs_date: ecsDate,
      ecs_max_time: ecsMaxTime,
      ecs_min_time: ecsMinTime,
      ecs_thing_name: ecsThingName,
    },
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => resp.data);
};

export const requestUpload = async (data) => {
  const { dataUrl, dataApiKey } = config || {};
  return axios({
    url: `${dataUrl}/upload`,
    method: 'POST',
    data,
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => resp.data);
};

export const list = async () => {
  const { dataUrl, dataApiKey } = config || {};
  return axios({
    url: dataUrl,
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => processListData(resp.data));
};

export default { list, request };
